import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { Bot } from '@core/bots';
import { GetBotInfoReq, Task, UpdateBotInfoReq } from './general-settings.abstraction';
import { BotLanguage } from '@core/languages';
import { Nullable } from '@pin-up-global/common';

@Injectable({
  providedIn: 'root',
})
export class GeneralSettingsApiService extends ApiService {
  isLoading$ = this._isLoading$;

  getBotInfo(params: GetBotInfoReq): Observable<Bot> {
    return this._httpClient
      .get<Bot>(`@api/settings/bots/${params.botId}/`)
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }

  updateBotInfo(params: UpdateBotInfoReq): Observable<Bot> {
    const { id, ...body } = params;

    return this._httpClient
      .patch<Bot>(`@api/settings/bots/${id}/`, body)
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }

  getDefaultLanguages(botId: number): Observable<ListResponse<BotLanguage>> {
    return this._httpClient
      .get<ListResponse<BotLanguage>>(`@api/settings/bots/${botId}/default-locale-options/`)
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }

  getBackgroundTasks(taskId: Nullable<string>): Observable<Task> {
    return this._httpClient
      .get<Task>(`@api/settings/tasks/${taskId}/`)
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }
}
